// extracted by mini-css-extract-plugin
module.exports = {"map":"SnackbarOverlay_map__dH2yY","wrapper":"SnackbarOverlay_wrapper__fZzKc","frame-popup":"SnackbarOverlay_frame-popup__1XrBH"};